import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/company/customer.company.unlink.mutation.gql"
import type {
  CustomerCompanyUnlinkMutation,
  CustomerCompanyUnlinkMutationVariables,
} from "@/v2-backoffice-client/customer/company/__types__/customer.company.unlink.mutation"

type Options = MutationHookOptions<
  CustomerCompanyUnlinkMutation,
  CustomerCompanyUnlinkMutationVariables
>

export function useCustomerCompanyUnlinkMutation(options?: Options) {
  return useMutation<
    CustomerCompanyUnlinkMutation,
    CustomerCompanyUnlinkMutationVariables
  >(mutation, options)
}
